import Vue from 'vue'
const bus =new Vue()
export default bus;


//////////////////
// WEBPACK FOOTER
// ./static/js/bus.js
// module id = sl3B
// module chunks = 19